import jsPDF from "jspdf";
import employeeLogo from "../../images/employee.png";
import Arabic from "../../images/arabic title.png";
import { convertToRFT } from "../../utils/convertToRFT";
import { BoxesPacking } from "../features/BoxesPacking";
import WarehousePrint from "./WarehousePrint";
import address from "../../images/arabic address.png";
import html2pdf from "html2pdf.js";
import { Balance, CompareArrows } from "@mui/icons-material";
import React from "react";
function DesignFivePrint({
  billNumber = "",
  customer = "",
  items = "",
  discount = "0",
  discountType = "",
  date = "",
  subTotal = "",
  Total = "",
  paid = "",
  formallyOutstandings = "0",
  saleType = "",
  notes = "",
  printQuote,
  Quote = "",
  fivePercent = "",
  gst = 0,
  gstType = "",
  varTotal,
  income = "0",
  further = "0",
  paymentMethod = "",
  bankName = "cash",
  cheque = "",
  currency = "",
  companyNew = "",
}) {
  let temp = localStorage.getItem("template");
  let companyCode = localStorage.getItem("companyCode");
  let baseUrl = localStorage.getItem("base_url");
  let imgSrc = baseUrl;
  console.log("img", imgSrc);
  let user = localStorage.getItem("username") || localStorage.getItem("token");
  let company = localStorage.getItem("company");
  let address = localStorage.getItem("address");
  let street = localStorage.getItem("street");

  let phone1 = localStorage.getItem("p1");
  let phone2 = localStorage.getItem("p2");
  let phone = localStorage.getItem("phone");
  let terms = localStorage.getItem("terms") || "";
  terms = terms.replace(/(\d+[\.\-])\s+/g, "\n$1 ");

  console.log("itemsssssss", items);
  console.log("itemsssssss", companyNew);
  // companyNew.partners_logos
  let totalQty = 0;

  const tableHeaderStyle = {
    border: "1px solid #ddd",
    padding: "8px",
    backgroundColor: "#333",
    color: "#fff",
    textAlign: "left",
  };
  const tableCellStyle = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
  };

  let rows = items
    .map((item, i) => {
      console.log("item", item);
      let { saleQty, itemPrice, totalPrice, discountAmount, itemDiscount } =
        convertToRFT(saleType, item, "", fivePercent);
      totalQty += parseInt(saleQty);
      let text;
      if (item.unit !== "" || item.saleType == "box") {
        text = "left !important";
        console.log("elseif");
      } else {
        text = "right !important";
        console.log("else");
      }
      return `
    <tr style="height:25px">
      <td  style="border: 1px solid #000; text-align: center; padding: 8px;">${
        i + 1
      }</td>
      <td style="border: 1px solid #000; text-align: center; padding: 8px;">${
        item?.name
      }</td>
  
     <td style="border: 1px solid #000; text-align: center; padding: 8px;">${
       companyNew.imeiNumberShow == "yes" ? item?.imeiNumber : item.description
     }</td>
  

<td style="border: 1px solid #000; text-align: center; padding: 8px;">
  ${saleQty}
</td>
       <td style="border: 1px solid #000; text-align: center; padding: 8px;">${
         itemPrice % 1 == 0 ? itemPrice : itemPrice.toFixed(3)
       }</td>
      <td style="border: 1px solid #000; text-align: center; padding: 8px;">${
        totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3)
      }</td>
    </tr>`;
    })
    .join("");

  let htmlContent = `



<div style=" font-family: Arial, sans-serif; padding: 20px;background-color:white">
  <!-- Logo and Company Info -->
  <div style="display: flex; justify-content: space-between; align-items: center;">
    <!-- Left Section: Logo and Brand Name -->
    <div style="flex: 1;">
    ${
      imgSrc
        ? `      <img src=${imgSrc} alt="Brand Logo" style="width: 70px; height: 70px;" />
`
        : ""
    }
      <h2 style="margin: 0; font-size: 20px; font-weight: bold;">${company}</h2>
    </div>
    
    <!-- Right Section: Invoice Label -->

  </div>

  <!-- Invoice Details -->
  <div style="margin-top: 20px; display: flex; justify-content: space-between;">
    <!-- Left Section: Customer Info -->
    <div style="flex: 1;">
      <p style="margin: 0; font-size: 14px; font-weight: bold;">Invoice to:</p>
      <p style="margin: 0; font-size: 12px;">${customer}</p>
     <p style="margin: 0; font-size: 12px;">${address}</p>

    </div>
    
    <!-- Right Section: Invoice Details -->
    <div style="flex: 1; text-align: right;">
      <p style="margin: 0; font-size: 12px;"><strong>Bill #</strong> ${billNumber}</p>
      <p style="margin: 0; font-size: 12px;"><strong>Date</strong> ${date}</p>
    </div>
  </div>
</div>




  <div id="invoice" style=" max-width: 800px; margin: auto; padding: 20px;">
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
      <thead>
        <tr>
          <th style="border: 1px solid #000; text-align: center; padding: 8px; background-color: #333; color: #fff;">No</th>
            <th style="border: 1px solid #000; text-align: center; padding: 8px; background-color: #333; color: #fff;">Item Name</th>

          <th style="border: 1px solid #000; text-align: center; padding: 8px; background-color: #333; color: #fff;">${
            companyNew.imeiNumberShow == "yes"
              ? "Imei Number"
              : "Item Description"
          }</th>

          <th style="border: 1px solid #000; text-align: center; padding: 8px; background-color: #333; color: #fff;">Qty</th>
          <th style="border: 1px solid #000; text-align: center; padding: 8px; background-color: #333; color: #fff;">Price</th>

          <th style="border: 1px solid #000; text-align: center; padding: 8px; background-color: #333; color: #fff;">Total</th>
        </tr>
      </thead>
      <tbody>
             ${rows}

      </tbody>
    </table>

    <div style="float: right; width: 50%;">
      <table style="width: 100%; border-collapse: collapse;">
        <tr>
          <th style="text-align: left; padding: 8px;">Sub Total</th>
          <td style="text-align: right; padding: 8px;">${
            Number(subTotal) % 1 === 0
              ? Number(subTotal)
              : Number(subTotal).toFixed(3)
          }</td>
        </tr>
        <tr>
          <th style="text-align: left; padding: 8px;">Previous Balance</th>
          <td style="text-align: right; padding: 8px;">${formallyOutstandings}</td>
        </tr>
           <tr>
          <th style="text-align: left; padding: 8px;">Discount</th>
          <td style="text-align: right; padding: 8px;">${discount}</td>
        </tr>
        <tr>
          <th style="text-align: left; padding: 8px; font-weight: bold;">Total</th>
          <td style="text-align: right; padding: 8px; font-weight: bold;">${
            Number(Total) % 1 === 0
              ? `${Number(Total)} ${currency}`
              : `${Number(Total).toFixed(3)} ${currency}`
          }</td>
        </tr>
      </table>
    </div>

  ${
    bankName !== "cash"
      ? `<div style="margin-top: 20px;">
 ${bankName && <p style="margin: 0;">Bank Name: ${bankName}</p>}
</div>`
      : ""
  }
  
  
<div style="display: flex; justify-content: space-between; align-items: flex-end; width: 100%; margin-top: 150px;">
  
  <!-- Left Section (Phone & Address) -->
  <div style="display: flex; gap: 10px;">
    <p style="margin: 0; line-height: 1.8;">📞 Phone<br>📍 Address</p>
    <p style="margin: 0; line-height: 1.8;">${phone}<br>${address}</p>
  </div>

  <!-- Right Section (Authorized Sign & Stamp) -->
  <div style="display: flex;flex-direction:column; align-items: center; justify-content: center;width:20%; gap: 10px;">
    <span style="border-top: 1px solid #000; padding-top: 5px; display: flex; justify-content: center; height: 40px;">
      Authorized Sign
    </span>
    <img src="${
      companyNew?.billStamp?.url
    }" style="width: 100px; height:auto;"/>
  </div>

</div>

  </div>


    


 


`;

  let opt = {
    margin: 0,
    filename: "receipt.pdf",
    image: { type: "jpeg", quality: 0.2 },
    html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }, // A4 size in portrait
  };

  html2pdf()
    .from(htmlContent)
    .set(opt)
    .output("blob")
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = function () {
          setTimeout(() => {
            newWindow.print();
          }, 3000); // Wait a second for the PDF to load before printing
        };
      } else {
        alert("Please allow popups for this website");
      }
    });
}

export default DesignFivePrint;
